import src from "IMAGE";
export default { src, width: 155, height: 42, blurWidth: 0, blurHeight: 0};
